exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-assets-jsx": () => import("./../../../src/pages/assets.jsx" /* webpackChunkName: "component---src-pages-assets-jsx" */),
  "component---src-pages-explore-js": () => import("./../../../src/pages/explore.js" /* webpackChunkName: "component---src-pages-explore-js" */),
  "component---src-pages-heroes-jsx": () => import("./../../../src/pages/heroes.jsx" /* webpackChunkName: "component---src-pages-heroes-jsx" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-rate-js": () => import("./../../../src/pages/rate.js" /* webpackChunkName: "component---src-pages-rate-js" */)
}

